import { useState } from "react";
import { Wrapper, Datagrid, DeleteActionIcon, Permission } from "components";

import {
  Typography,
  IconButton,
  Button,
  Card,
  CardContent,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@material-ui/core/styles";
import { endpoints } from "appConfigs";
import { useFetch } from "hooks";
import format from "date-fns/format";
import Form from "./Form";
import Filters from "./Filters";
import { useAppState } from "components/AppProvider/AppProvider";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  titleBar: {
    padding: "1rem 0 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  centered: {
    margin: "0 auto",
  },
  label: {
    color: "#ffffff",
  },
}));

const Users = () => {
  const { authUser } = useAppState();
  const classes = useStyles();
  const [edit, setEdit] = useState(null);
  const [filters, setFilters] = useState({});
  const { remove: deleteItem, loading: deleting } = useFetch(
    endpoints.serviceProviders
  );
  return (
    <>
      <Wrapper padding={false}>
        <Grid container spacing={0} justify="center">
          <Grid item xs={10}>
            <Grid container spacing={1} direction="column" justify="center">
              <Grid item className={classes.titleBar}>
                <Typography variant="h5">
                  <FormattedMessage
                    id="serviceProviders"
                    defaultMessage="Service Providers"
                  />
                </Typography>
                <Permission permission="add_service_provider">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setEdit(true)}
                  >
                    <FormattedMessage
                      id="addServiceProvider"
                      defaultMessage="Add ServiceProvider"
                    />
                  </Button>
                </Permission>
              </Grid>
              <Grid item>
                <Card>
                  <CardContent>
                    <Filters
                      filters={filters}
                      setFilters={setFilters}
                      authUser={authUser}
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Datagrid
                url={endpoints.serviceProviders}
                columns={[
                  {
                    headerName: (
                      <FormattedMessage id="name" defaultMessage="Name" />
                    ),
                    field: "name",
                  },
                  {
                    headerName: (
                      <FormattedMessage
                        id="serviceMode"
                        defaultMessage="Service Mode"
                      />
                    ),
                    field: "service_mode",
                  },
                  {
                    headerName: (
                      <FormattedMessage id="status" defaultMessage="Status" />
                    ),
                    field: "status",
                  },
                  {
                    headerName: (
                      <FormattedMessage id="action" defaultMessage="Action" />
                    ),
                    field: "action",
                    renderCell: ({ row }) => (
                      <>
                        <Permission permission="update_service_providers">
                          <IconButton
                            aria-label={
                              <FormattedMessage
                                id="editServiceProvider"
                                defaultMessage="Edit Service Provider"
                              />
                            }
                            onClick={() => setEdit(row)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Permission>
                        <Permission permission="remove_service_providers">
                          <DeleteActionIcon
                            aria-label={
                              <FormattedMessage
                                id="deleteServiceProvider"
                                defaultMessage="Delete Service Provider"
                              />
                            }
                            title={
                              <FormattedMessage
                                id="deleteServiceProvider"
                                defaultMessage="Delete Service Provider"
                              />
                            }
                            message={
                              <FormattedMessage
                                id="deleteConfirmation_service_provider"
                                defaultMessage="Are you sure want to remove this service provider?"
                              />
                            }
                            disabled={deleting}
                            deleteRecord={() => {
                              deleteItem({ ids: [row.id] })
                                .then(({ data }) => {
                                  if (data?.success) {
                                    setFilters((prev) => ({ ...prev }));
                                    return NotificationManager.success(
                                      data.message
                                    );
                                  }
                                  NotificationManager.error(data.message);
                                })
                                .catch((err) =>
                                  NotificationManager.error(err.message)
                                );
                            }}
                          />
                        </Permission>
                      </>
                    ),
                  },
                ]}
                filters={filters}
              />
            </Grid>
          </Grid>
        </Grid>
        <Form
          authUser={authUser}
          open={!!edit}
          edit={edit}
          setEdit={setEdit}
          onSuccess={(newItem) => {
            setFilters((prev) => ({ ...prev }));
            setEdit(null);
          }}
        />
      </Wrapper>
    </>
  );
};

export default Users;
